import "./global-css/global-reset.css";
import styles from "./global-css/app.module.css";
import InfoPanel from "./comps/infoPanel/InfoPanel";
import PifflePlaque from "./comps/pifflePlaque/PifflePlaque";
import { useState } from "react";
import ControlsPanel from "./comps/controlsPanel/ControlsPanel";
import {
  generateDescription,
  generateTitle,
  getNameForDescriptions,
} from "./textFunctions";

const defaultName = "Dävé Plimsole";
const defaultMedia = "Felt tip on Scrap Paper";
const defaultBirthYear = 1999;

function App() {
  const [name, setName] = useState(defaultName);
  const [creationYear, setCreationYear] = useState(() =>
    new Date().getFullYear()
  );
  const [birthYear, setBirthYear] = useState(defaultBirthYear);
  const [media, setMedia] = useState(defaultMedia);
  const [title, setTitle] = useState(() => generateTitle());
  const [description, setDesciption] = useState(() => generateDescription());

  const nameForDescription = getNameForDescriptions(name);

  const controlsProps = {
    name,
    setName,
    creationYear,
    setCreationYear,
    birthYear,
    setBirthYear,
    media,
    setMedia,
    title,
    setTitle,
    description,
    setDesciption,
  };

  return (
    <div className={styles.app}>
      <main>
        <PifflePlaque
          name={name}
          title={title}
          description={`${nameForDescription} ${description}`}
          media={media}
          birthYear={birthYear}
          creationYear={creationYear}
        />
        <ControlsPanel {...controlsProps} />
      </main>
      <InfoPanel />
    </div>
  );
}

export default App;
